import { createSelector } from '@reduxjs/toolkit';

import { selectCohortBuilderState } from './cohortBuilderEditModalSelectors';

// Selects the cohort builder workflow state
export const selectCohortBuilderWorkflow = createSelector(
  selectCohortBuilderState,
  (cohortBuilderState) => cohortBuilderState?.cohortBuilderWorkflow
);

// Selects whether the process button is enabled
export const selectIsProcessEnabled = createSelector(
  selectCohortBuilderWorkflow,
  (cohortDefinition) => cohortDefinition?.isProcessEnabled
);

// Selects whether the definition has been modified
export const selectHasUnsavedChanged = createSelector(
  selectCohortBuilderWorkflow,
  (cohortDefinition) => cohortDefinition?.hasUnsavedChanged
);

// Selects the active modal to display
export const selectModal = createSelector(
  selectCohortBuilderWorkflow,
  (cohortDefinition) => cohortDefinition?.modal
);

// Selects the in use cohort builder items map
export const selectInUseCohortBuilderItemsMap = createSelector(
  selectCohortBuilderWorkflow,
  (cohortDefinition) => cohortDefinition?.inUseCohortBuilderItemsMap
);

// Selects the cohort builder item names to ids map
export const selectCohortBuilderItemNamesToIdsMap = createSelector(
  selectCohortBuilderWorkflow,
  (cohortDefinition) => cohortDefinition?.cohortBuilderItemNamesToIdsMap
);

// Selects the cohort builder item ids to names map
export const selectCohortBuilderItemIdsToNamesMap = createSelector(
  selectCohortBuilderWorkflow,
  (cohortDefinition) => cohortDefinition?.cohortBuilderItemIdsToNamesMap
);

// Selects if the cohort builder item has been viewed
export const selectCohortBuilderItemViewed = (id: string) =>
  createSelector(
    selectCohortBuilderWorkflow,
    (cohortBuilderWorkflow) => cohortBuilderWorkflow?.viewedCohortBuilderItems?.[id]
  );

// Selects if the cohort builder item has been viewed
export const selectViewedCohortBuilderItems = createSelector(
  selectCohortBuilderWorkflow,
  (cohortBuilderWorkflow) => cohortBuilderWorkflow?.viewedCohortBuilderItems
);
